export const filePermissionsConst = {
  view: {
    value: "view_file",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu pliku!",
  },
  add: {
    value: "add_file",
    errorMsg: "Użytkownik nie ma uprawnień do dodania pliku!",
  },
  update: {
    value: "change_file",
    errorMsg: "Użytkownik nie ma uprawnień do edycji pliku!",
  },
  delete: {
    value: "delete_file",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania pliku!",
  },
};
